import theme from '@styles/theme';
export default {
  mosaicBlock: (bg: string, reverse: boolean, color = theme.rawColors.darkGrey700) => ({
    bg,
    display: 'flex',
    flexDirection: reverse ? ['row', 'row', 'row', 'row-reverse'] : 'row',
    flexWrap: 'wrap',
    color,
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  contentBlock: {
    width: ['100%', '100%', '100%', '50%'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: ['center', 'center', 'center', 'left'],
    padding: ['17.0666667vw 10.6666667vw 10.6666667vw', '17.0666667vw 10.6666667vw 10.6666667vw', '10.4166667vw 8.33333333vw 7.29166667vw', '64px 40px'],
    div: {
      'div, h2': {
        maxWidth: ['100%', '100%', '100%', 570],
        width: '100%'
      },
      div: {
        fontSize: theme.fontSizes.text,
        lineHeight: '175%',
        letterSpacing: theme.letterSpacings.smallCaps
      }
    },
    button: {
      mt: '16px'
    },
    a: {
      mt: '16px',
      textDecoration: 'none'
    }
  },
  imageContent: {
    position: 'relative',
    width: ['100%', '100%', '100%', '50%'],
    height: ['106.133333vw', '106.133333vw', '100vw', '46.875vw'],
    img: {
      objectFit: 'cover'
    }
  },
  textColor: (color = theme.rawColors.darkGrey700, lineSpacing = 16) => ({
    color,
    'h1, h2, h3, h6, h7': {
      mb: `${lineSpacing}px`
    },
    'p, ul': {
      mb: `${lineSpacing}px`
    }
  })
};